import { getSubjectColorIndex } from "@/lib/strapi/formatters";
import { Resources } from "@/types/subject-schema";
import { buildFullPath, getUserPreferredSubTopicTitle } from "@utils/routing";
import {
  useMultipleSubTopicMeta,
  useTopicMeta,
} from "../../../../../../components/CoreDataProvider";
import TabsComponent from "./TabsComponent";

export default function SubTopicTabs({
  subjectNameLower,
  currentResource,
  topicDocumentId,
  relevantSubTopicDocumentIds,
  currentSubTopicId,
}: {
  subjectNameLower: string;
  currentResource: Resources | "all";
  topicDocumentId: string;
  relevantSubTopicDocumentIds: string[];
  currentSubTopicId?: string;
}) {
  const subjectColorIndex = getSubjectColorIndex(subjectNameLower);
  const topicMeta = useTopicMeta(topicDocumentId);
  const subTopicMetaArray = useMultipleSubTopicMeta(
    relevantSubTopicDocumentIds
  );
  const subTopicTabs = Object.values(subTopicMetaArray).map((subTopicMeta) => {
    return {
      label: getUserPreferredSubTopicTitle(subTopicMeta),
      value: `${buildFullPath({
        subject: subjectNameLower,
        resource: currentResource,
        topicNumber: topicMeta.index.toString(),
        topicTitle: topicMeta.title,
        subTopicTitle: subTopicMeta.title,
      })}${subTopicMeta.subThemes ? "?activeTheme=all" : ""}`,
    };
  });
  subTopicTabs.unshift({
    label: `All topic ${topicMeta.number} sub-topics`,
    value: buildFullPath({
      subject: subjectNameLower,
      resource: currentResource,
      topicNumber: topicMeta.index.toString(),
      topicTitle: topicMeta.title,
      // don't need subTopicTitle for all so it points to topic page
    }),
  });
  return (
    <TabsComponent
      type={"subTopic"}
      subjectColorIndex={subjectColorIndex}
      tabs={subTopicTabs}
      activeTabValue={`${buildFullPath({
        subject: subjectNameLower,
        resource: currentResource,
        topicNumber: topicMeta.index.toString(),
        topicTitle: topicMeta.title,
        subTopicTitle: currentSubTopicId
          ? subTopicMetaArray[currentSubTopicId].title
          : undefined,
      })}${
        currentSubTopicId && subTopicMetaArray[currentSubTopicId].subThemes
          ? `?activeTheme=all`
          : ""
      }`}
    />
  );
}
